import { render } from "./InvoiceReportTable.vue?vue&type=template&id=56f27e1c&scoped=true"
import script from "./InvoiceReportTable.vue?vue&type=script&lang=js"
export * from "./InvoiceReportTable.vue?vue&type=script&lang=js"

import "./InvoiceReportTable.vue?vue&type=style&index=0&id=56f27e1c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f27e1c"]])

export default __exports__